import MainLayoutContainer from './MainLayout.container';

export default MainLayoutContainer;
